import React from 'react';
import { ratingStrings as copy } from '../../content/ratings';

/** Accessible half-star selector. Receives nullable rating and emits a half-step value or null on clear. */
export default function HobbyStarRating({ value, onChange }) {
  const rating = Number(value || 0);
  return <div className="star-rating-wrap">
    <div className="star-rating" role="radiogroup" aria-label={copy.rating}>
      {[1, 2, 3, 4, 5].map(star => <span className={`star-button ${rating >= star ? 'full' : rating >= star - 0.5 ? 'half' : 'empty'}`} key={star}>
        <span className="star-icon" aria-hidden="true">★</span>
        {[star - 0.5, star].map((score, index) => <button key={score} type="button" role="radio" aria-checked={rating === score} className={`star-hit star-hit-${index ? 'right' : 'left'}`} aria-label={copy.label(score)} onClick={() => onChange(score)} />)}
      </span>)}
    </div>
    <div className="star-rating-summary"><span>{rating ? copy.value(rating) : copy.notRated}</span>{rating > 0 && <button type="button" className="btn-ghost compact-btn" onClick={() => onChange(null)}>{copy.clear}</button>}</div>
  </div>;
}
